<template>
  <div
    class="cell"
    :style="styles"
  />
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'Cell',

  props: {
    data: Object,
  },

  setup(props) {
    const styles = computed(() => ({
      height: `${props.data.pixels}px`,
      backgroundColor: props.data.color,
      opacity: props.data.isOpacity ? '0%' : '100%',
    }));

    return {
      styles,
    };
  },
};
</script>

<style lang="scss" scoped>
  .cell {
    border-radius: 15px;
    max-width: calc((100vw - 72px) / 7);
    min-width: 110px;
    position: relative;
}
</style>
